<template>
    <base-layout title="设备使用信息" :hideFooter="true">
        <template slot="main">
            <div class="page-body">
                <p>数据更新说明：部分数据可能存在同步延迟。</p>
                <ul>
                    <li v-for="(info,index) in dataList" :key="index">
                        <dl>
                            <dt>
                                {{ info.title }}
                            </dt>
                            <dd v-for="(item,index_two) in info.list" :key="index_two">
                                <strong>{{ item.name }}</strong>
                                <p @click="toPage(item.href)" :class="item.href !== undefined?'a':''">{{
                                        item.content
                                    }}</p>
                            </dd>
                        </dl>
                    </li>
                </ul>
            </div>
        </template>
    </base-layout>
</template>

<script>
// 页面布局组件
import baseLayout from "@comm/view/layout/baseLayout";
// app dataStore
import appStore from '@comm/store/app.store';
// 地址数据管理
import {getAddressList} from '@comm/store/address.store'
// 浏览器解析
import UA from "ua-device";
// 设备信息
const deviceInfo = new UA(navigator.userAgent)

function getDataList(userAddress) {
    return [
        {
            title: '位置信息',
            list: [
                {
                    name: '使用目的',
                    content: '展示所在区域可以享受的服务'
                },
                {
                    name: '使用场景',
                    content: '使用APP过程中'
                },
                {
                    name: '收集情况',
                    content: appStore.getters.locationState || userAddress ? '己收集' : '未收集'
                },
                {
                    name: '信息内容',
                    content: '选择城市',
                    href: "/findStore",
                }
            ]
        },
        {
            title: '设备信息',
            list: [
                {
                    name: '使用目的',
                    content: '用于订单交易履约'
                },
                {
                    name: '使用场景',
                    content: '保障账户安全、识别账户异常状态、了解产品适配性以及信息推荐功能'
                },
                {
                    name: '收集情况',
                    content: '己收集'
                },
                {
                    name: '信息内容',
                    content: `${deviceInfo.device.type === "mobile" ? "手机类型：" + (deviceInfo.device.model || deviceInfo.os.name) + '\r\t\n' : ''}操作系统：${deviceInfo.os.name} ${deviceInfo.os.version.original}\r\t\n浏览器引擎：${deviceInfo.engine.name} ${deviceInfo.engine.version.original}`
                }
            ]
        }
    ]
}

export default {
    name: 'systemStatuteCollectionDeviceUseInfo',
    components: {
        // 页面布局组件
        baseLayout,
    },
    data() {
        return {
            dataList: getDataList(false),
        }
    },
    created() {
        // 获取地址列表
        getAddressList(true).then(addressList => {
            this.dataList = getDataList(addressList.length)
        }, err => {

        });
        // 查询用户是否下过单
        // this.$service("isExistOrder")
        //     .success(isExistOrder => {
        //         this.dataList = getDataList(isExistOrder)
        //     })
        //     .send();
    },
    methods: {
        // 页面跳转
        toPage(href) {
            if (href) this.$router.push({path: href, query: {back: true}})
        }
    },
}
</script>

<style lang="scss" scoped>
.page-body {
    padding: 10px;
    height: 100%;
    overflow-y: scroll;
    position: relative;
    box-sizing: border-box;

    > p {
        color: gray;
        font-size: 12px;
        padding-bottom: 5px;
    }

    ul {
        li {
            padding-bottom: 10px;
        }
    }

    dl {
        padding: 10px;
        border-radius: 5px;
        background-color: #f7f7f7;
    }

    dt {
        font-size: 14px;
        font-weight: bold;
        padding-bottom: 5px;
    }

    dd {
        display: flex;
        position: relative;
        align-content: center;
        align-items: flex-start;
        justify-content: flex-start;
        min-height: 25px;

        strong {
            min-width: 60px;
            display: block;
            font-weight: normal;
        }

        p {
            flex: 1;
            display: flex;
            color: #999CA0;
            white-space: pre-line;

            &.a {
                color: #2c4adc;
                text-decoration: underline;
            }
        }
    }
}
</style>